import BaseClass from "../BaseClass.js";


export default class ButtonToggle extends BaseClass {
    static config = {
        regex: {
            style: /^btn(-outline)?-(primary|secondary|success|info|warning|danger)/,
        },
    }

    config = ButtonToggle.config;

    constructor(element) {
        super(element);
        this.$input = this.$element.find('input[type="hidden"]');
        this.$form = this.$element.parents('form');
        this.autoSubmit = false;

        this.init();
    }

    init() {

        const autoSubmit = this.$element.data('auto-submit');
        if (typeof autoSubmit !== 'undefined' && autoSubmit) {
            this.autoSubmit = true;
        }

        let mySelf = this;
        this.$element.on('click', function (event) {
            mySelf.onToggleClick(event);
        });

    }

    onToggleClick(event) {
        const currentStyleClass = this.getStyle(true);
        const style = this.getStyle();

        let value = this.$input.val();
        if (typeof value === 'undefined' || value === null || value === '') {
            value = 1;
        } else {
            value = null;
        }

        this.$input.val(value);

        if (style !== null) {
            this.$element.removeClass(currentStyleClass);

            let styleClass = 'btn-';
            if (value === null) {
                styleClass += 'outline-';
            }
            styleClass += style;

            this.$element.addClass(styleClass);
        }

        if (this.autoSubmit) {
            this.$form.submit();
        }
    }

    getStyle(returnClass = false) {
        let style = null;
        for (const currentClass of this.element.classList) {
            const match = currentClass.match(this.config.regex.style);

            if (match) {
                if (returnClass) {
                    style = currentClass;
                } else {
                    style = match[2];
                }
                break;
            }
        }

        return style;
    }
}